import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { wait } from '../../utils/wait';
import { SuggestionImage } from './suggestion-image';

const animation = 'animate__animated animate__fadeIn';
const animationFromRight =
  'animate__animated animate__fadeInRight animate__delay-1s';

function SubmitOrderModalBody({
  suggestions,
  onClick,
  storage,
  analyticsFeatureUseEvent,
}) {
  const { userRef } = storage;
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  // const [showInstructions, setShowInstructions] = useState(false);
  const classes = useStyles();

  async function handleClick(suggestion) {
    await wait(200);

    // setTimeout(() => {
    onClick?.call(this, suggestion);
    // }, 100);
  }

  async function handleScroll() {
    if (!scrolled) {
      setScrolled(true);
      analyticsFeatureUseEvent('ordering suggestion scroll');
    }
  }

  return (
    <div className={classNames(classes.container, animation)}>
      <div
        className={classNames(classes.suggestions, animationFromRight)}
        style={{ '--animate-delay': '0.5s' }}
        onTouchMove={(event) => event.stopPropagation()}
        onScroll={handleScroll}
      >
        {suggestions?.map((s, i) => (
          <div
            key={s.item.id}
            className={classNames(
              classes.suggestion,
              i === 0 && classes.first,
              i === (suggestions?.length ?? 1) - 1 && classes.last
            )}
          >
            <SuggestionImage suggestion={s} onClick={() => handleClick(s)} />
          </div>
        ))}
      </div>
      <div className={classes.titleContainer}>
        <div className={classes.title}>
          {' '}
          {userRef.current?.name}, {t('submit-order-modal-body.how-about')}
        </div>
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    paddingTop: layoutDefaults.smallestVerticalMargin,
    paddingLeft: layoutDefaults.smallestHorizontalMargin,
    paddingRight: layoutDefaults.smallestHorizontalMargin,
    paddingBottom: layoutDefaults.smallerVerticalMargin,

    width: '100%',
    // border: "1px solid red",
  },
  titleContainer: {
    display: 'flex',
  },
  title: {
    // display: "flex",
    // flex: 1,
    color: '#f5f5f5',
    fontSize: layoutDefaults.smallerFontSize,
    textTransform: 'uppercase',
    backgroundColor: '#a2a2a2',
    marginLeft: '1.5em',
    marginTop: 6,
    marginBottom: -12,
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 6,
    paddingRight: 4,
    borderRadius: layoutDefaults.radius,
  },
  suggestions: {
    overflowX: 'scroll',
    scrollbarWidth: 'none',
    whiteSpace: 'nowrap',

    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  suggestion: {
    display: 'inline-block',
    marginLeft: layoutDefaults.horizontalMargin,
  },
  first: {
    marginLeft: '1.3em',
  },
  last: {
    marginRight: '1.3em',
  },
});

export { SubmitOrderModalBody };
